export default __webpack_public_path__ + "static/media/downicon.37d9da17.svg";